import { Query, useQuery } from '@tanstack/react-query'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { getPollingGCTime } from '@omnea-app/frontend/utils/react-query/queryConfig'
import { throwIfApiError } from '@omnea-app/legacy/utils/error-handling/throwifApiError'
import { GetRequestStepsResponse } from '@omnea-app/requests/requestsFrontendClient'
import { RequestsHttpClient } from '@omnea-app/requests/requestsHttpClient'

export const RequestStepsQueryKey = 'GetRequestSteps'

const isGetRequestStepsResponse = (data: unknown): data is GetRequestStepsResponse => {
  if (typeof data !== 'object' || data === null) return false
  const candidate = data as Record<string, unknown>
  return Array.isArray(candidate.requestSteps)
}

const fetchRequestSteps = async (token: string, requestId: string): Promise<GetRequestStepsResponse> => {
  const apiClient = new RequestsHttpClient({ authorization: token })
  const { data, error } = await apiClient.GET('/{id}/steps', {
    params: { path: { id: requestId } },
  })
  throwIfApiError(error)

  if (!isGetRequestStepsResponse(data)) {
    throw new Error('Invalid response format from getRequestSteps API')
  }

  return data
}
type UseGetRequestStepsProps = {
  requestId: string
  refetchInterval?: number | false | ((query: Query<GetRequestStepsResponse>) => number | false)
  enabled?: boolean
}
export const useGetRequestSteps = ({ requestId, refetchInterval, enabled = true }: UseGetRequestStepsProps) => {
  const { getToken } = useAuthenticatedUser()
  return useQuery({
    queryKey: [RequestStepsQueryKey, requestId],
    gcTime: getPollingGCTime(typeof refetchInterval === 'function' ? true : refetchInterval),
    refetchInterval,
    enabled,
    queryFn: async () => {
      const token = await getToken()
      return fetchRequestSteps(token, requestId)
    },
  })
}
